<template>
<div>
<div style="display: flex;margin-top: 20px;">
        <div  style="width: 50%;"><span style="color: rgb(154, 154, 175);">厂家品牌</span><span class="contentStyle"> {{machineInfo.brand?machineInfo.brand:''}}</span></div>
        <div><span style="color: rgb(154, 154, 175);">仪器型号</span><span class="contentStyle">{{machineInfo.type?machineInfo.type:''}}</span></div>
    </div>
</div>
</template>

<script>
    export default {
        name: "GetMachineInfo",
        props: {
            machineInfo: {}
        }
    }
</script>

<style scoped>
    @import "../../../assets/element-component.css";
.contentStyle{
    font-size: 17px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 0 0 0 60px;
}
</style>